module.exports = __webpack_public_path__ + "img/slide.cc03b435.jpg";